<svg:g app-blank-goban
       [width]="state().getWidth()"
       [height]="state().getHeight()"
       (clickCallBack)="onClick($event)"
       (mouseEnterCallback)="onOptionalMouseOver($event)"
/>
<svg:g class="data-piece-ko-territory-markers-and-dead-stones">
    @for (coordAndContent of state().getCoordsAndContents(); track coordAndContent.coord.toString()) {
        <svg:g class="data-coord-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
               [attr.transform]="getTranslationAt(coordAndContent.coord)"
               (mouseenter)="onMouseEnter(coordAndContent.coord)"
               (mouseleave)="onSVGLeave()"
               (click)="onClick(coordAndContent.coord)"
        >
            @if (spaceIsFull(coordAndContent.coord)) {
                <svg:g>
                    <svg:circle [attr.cx]="SPACE_SIZE * 0.5"
                                [attr.cy]="SPACE_SIZE * 0.5"
                                [attr.r]="SPACE_SIZE * 0.44"
                                [ngClass]="getSpaceClass(coordAndContent.coord)"
                                class="base"
                    />
                    @if (isLastSpace(coordAndContent.coord)) {
                        <svg:circle [attr.cx]="SPACE_SIZE * 0.5"
                                    [attr.cy]="SPACE_SIZE * 0.5"
                                    [attr.r]="SPACE_SIZE * 0.44"
                                    class="base no-fill last-move-stroke"
                        />
                    }
                    @if (isDead(coordAndContent.coord)) {
                        <svg:line [attr.x1]="0"
                                  [attr.y1]="0"
                                  [attr.x2]="SPACE_SIZE"
                                  [attr.y2]="SPACE_SIZE"
                                  class="base no-fill captured-stroke"
                        />
                    }
                </svg:g>
            } @else {
                @if (isTerritory(coordAndContent.coord)) {
                    <svg:circle [attr.cx]="SPACE_SIZE * 0.5"
                                [attr.cy]="SPACE_SIZE * 0.5"
                                [attr.r]="SPACE_SIZE * 0.2"
                                [attr.class]="coordAndContent.content === GoPiece.LIGHT_TERRITORY ? 'player1-fill' : 'player0-fill'"
                    />
                }
            }
        </svg:g>
    }
</svg:g>
@if (adaptedKo().isPresent()) {
    <svg:rect [attr.transform]="getTranslationAt(adaptedKo().get())"
              [attr.width]="SPACE_SIZE * 0.5"
              [attr.height]="SPACE_SIZE * 0.5"
              [attr.x]="SPACE_SIZE * 0.25"
              [attr.y]="SPACE_SIZE * 0.25"
              class="captured-stroke mid-stroke no-fill data-ko data-ko-{{ adaptedKo().get().x }}-{{ adaptedKo().get().y }}"
    />
}
@if (adaptedHover().isPresent()) {
    <svg:circle [attr.transform]="getTranslationAt(adaptedHover().get())"
                [attr.cx]="SPACE_SIZE * 0.5"
                [attr.cy]="SPACE_SIZE * 0.5"
                [attr.r]="SPACE_SIZE * 0.50"
                class="semi-transparent click-delegator data-hover data-hover-{{ adaptedHover().get().x }}-{{ adaptedHover().get().y }}"
    />
}
@for (capture of adaptedCaptures(); track capture.toString()) {
    <svg:circle [attr.transform]="getTranslationAt(capture)"
                [attr.cx]="SPACE_SIZE * 0.5"
                [attr.cy]="SPACE_SIZE * 0.5"
                [attr.r]="SPACE_SIZE * 0.14"
                class="captured-fill click-delegator data-capture data-capture-{{ capture.x }}-{{ capture.y }}"
    />
}